import {
  DeleteOutlined,
  PlusOutlined,
  RollbackOutlined,
} from '@ant-design/icons';
import { Button, Card, Col, Row, Select, Space, Typography } from 'antd';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { CONDITION_OPERATORS } from '../../../../../utils/const/mapping';
import ConditionCard from './ConditionCard';

const { Text } = Typography;

// FIXME: handle remove condition when its logical
const ConditionBuilder = ({
  index = 0,
  condition,
  onChange,
  onRemove,
  depth = 0,
  maxDepth = 5,
  fieldNamePrefix = [], // Préfixe pour les noms de champs Form.Item
}) => {
  const isLogical = (op) => ['and', 'or'].includes(op);

  const handleOperatorChange = (newOperator) => {
    if (isLogical(newOperator)) {
      const newConditions = condition.conditions || [
        { uuid: uuidv4(), field: '', operator: 'equals', value: '' },
      ];

      onChange({
        ...condition,
        operator: newOperator,
        conditions: newConditions,
        field: undefined,
        value: undefined,
      });
    } else {
      onChange({
        ...condition,
        operator: newOperator,
        conditions: undefined,
        field: condition.field || '',
        value: condition.value || '',
      });
    }
  };

  const handleFieldChange = (val) => onChange({ ...condition, field: val });
  const handleValueChange = (val) => onChange({ ...condition, value: val });

  const handleAddSubCondition = () => {
    const newSub = {
      uuid: uuidv4(),
      field: '',
      operator: 'equals_str',
      value: '',
    };
    onChange({
      ...condition,
      conditions: [...(condition.conditions || []), newSub],
    });
  };

  const handleUpdateSubCondition = (index, updatedSub) => {
    const newConditions = [...condition.conditions];
    newConditions[index] = updatedSub;
    onChange({ ...condition, conditions: newConditions });
  };

  const handleRemoveSubCondition = (index) => {
    const newConditions = condition.conditions.filter((_, i) => i !== index);
    onChange({ ...condition, conditions: newConditions });
  };

  const isLogicalCondition = isLogical(condition.operator);

  console.log('condition', condition);

  if (isLogicalCondition) {
    return (
      <Card
        size="small"
        style={{
          borderLeft: '8px solid #52C41A',
          marginBottom: 8,
          // backgroundColor: '#f9f9f9',
        }}
      >
        <Row gutter={[8, 8]} align="middle">
          <Col flex="auto">
            <Space>
              <Text strong>Opérateur Logique:</Text>
              <Select
                value={condition.operator}
                onChange={handleOperatorChange}
                style={{ width: 350 }}
                options={CONDITION_OPERATORS.filter(
                  (op) => op.category === 'logical'
                )}
              />
              {onRemove && (
                <Button
                  type="link"
                  danger={!isLogicalCondition}
                  icon={
                    isLogicalCondition ? (
                      <RollbackOutlined />
                    ) : (
                      <DeleteOutlined />
                    )
                  }
                  onClick={onRemove}
                  block
                />
              )}
            </Space>
          </Col>
        </Row>

        <div style={{ marginTop: 12, paddingLeft: 12 }}>
          {condition.conditions?.map((subCondition, index) => (
            <div
              key={subCondition.uuid || index}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: 8,
              }}
            >
              <div style={{ flex: 1 }}>
                <ConditionBuilder
                  index={index}
                  onRemove={() => {
                    handleRemoveSubCondition(index);
                  }}
                  condition={subCondition}
                  onChange={(updated) =>
                    handleUpdateSubCondition(index, updated)
                  }
                  depth={depth + 1}
                  maxDepth={maxDepth}
                  fieldNamePrefix={[...fieldNamePrefix, 'conditions', index]}
                />
              </div>
            </div>
          ))}
          {(!condition.conditions || condition.conditions.length === 0) && (
            <Text type="secondary" style={{ fontStyle: 'italic' }}>
              Aucune sous-condition
            </Text>
          )}
          {depth < maxDepth && (
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              onClick={handleAddSubCondition}
              block
              style={{ marginTop: 8, backgroundColor: '#52C41A12' }}
            >
              Ajouter Condition
            </Button>
          )}
        </div>
      </Card>
    );
  }

  return (
    <ConditionCard
      index={index}
      condition={condition}
      onFieldChange={handleFieldChange}
      onOperatorChange={handleOperatorChange}
      onValueChange={handleValueChange}
      handleDeleteCondition={onRemove ? onRemove : null}
      simpleMode={true}
      isLogicalCondition={isLogicalCondition}
      fieldNamePrefix={fieldNamePrefix}
    />
  );
};

export default ConditionBuilder;
